import { Box } from '@rbilabs/universal-components';

export const UpsellCarouselWrapper = Box.withConfig({
  marginLeft: 4,
  _web: {
    marginTop: 3,
  },
});
